export default {
  lesionLocations: ["RCA", "LAD", "LCX", "LM", "pLCx", "pRCA", "pLAD", "mLAD", "mRCA", "OM-LCX", "pLCX"]

} as const;
